import {
  FormControl,
  InputLabel,
  TextField,
  Select,
  MenuItem,
  Grid2,
  Divider,
  Box,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";

const CharacterSearchAndFilter = ({
  searchInputCharacter,
  handleSearchChange,
  filteredType,
  handleTypeChange,
}) => {
  // Character group list
  const characterMenuFilters = [
    { types: "Protagonists", name: "Protagonists" },
    { types: "Detective_Boys", name: "Detective Boys" },
    { types: "Family_Friends", name: "Family & Friends" },
    { types: "Kaitou_Kid", name: "Kaitou Kid" },
    { types: "Black_Organization", name: "Black Organization" },
    { types: "Law_Enforcement", name: "Law Enforcement" },
    { types: "Tokyo_Police", name: "Tokyo Police" },
    { types: "Osaka_Police", name: "Osaka Police" },
    { types: "Nagano_Police", name: "Nagano Police" },
    { types: "FBI", name: "FBI" },
    { types: "NPA_PSB", name: "NPA & PSB" },
    { types: "F5", name: "Police Academy" },
    { types: "Celebrity", name: "Celebrity" },
  ];

  // Map icons + labels for renderValue
  const filterDisplayMap = {
    "": { label: "All" },

    Male: {
      label: "Male",
      icon: <MaleIcon color="primary" />,
    },
    Female: {
      label: "Female",
      icon: <FemaleIcon style={{ color: "#FF00FF" }} />,
    },

    Alive: {
      label: "Alive",
      icon: <CircleIcon style={{ color: "#6EC531" }} />,
    },
    Dead: {
      label: "Dead",
      icon: <CircleIcon style={{ color: "red" }} />,
    },
  };

  // Add entries for characterMenuFilters (no icons)
  characterMenuFilters.forEach((f) => {
    filterDisplayMap[f.types] = { label: f.name };
  });

  return (
    <Grid2 container spacing={{ xs: 1, md: 2 }} sx={{ paddingBottom: "15px" }}>
      {/* Search Input */}
      <Grid2 size={{ xs: 8, md: 9 }}>
        <TextField
          fullWidth
          label="Type name here..."
          variant="filled"
          value={searchInputCharacter}
          onChange={handleSearchChange}
          className="search-and-filter"
        />
      </Grid2>

      {/* Filter Menu */}
      <Grid2 size={{ xs: 4, md: 3 }}>
        <FormControl fullWidth variant="filled" className="search-and-filter">
          <InputLabel id="group-filter-label">Filter</InputLabel>

          <Select
            labelId="group-filter-label"
            id="group-filter"
            value={filteredType}
            onChange={handleTypeChange}
            label="Filter"
            sx={{
              "& .MuiSelect-select": {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
            }}
            renderValue={(selected) => {
              const item = filterDisplayMap[selected];
              if (!item) return "All";

              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {item.icon}
                  {item.label}
                </Box>
              );
            }}
          >
            {/* ALL */}
            <MenuItem value="">All</MenuItem>
            <Divider />

            {/* Gender */}
            <MenuItem value="Male">
              <Box display="flex" alignItems="center" gap={1}>
                <MaleIcon color="primary" /> Male
              </Box>
            </MenuItem>

            <MenuItem value="Female">
              <Box display="flex" alignItems="center" gap={1}>
                <FemaleIcon style={{ color: "#FF00FF" }} /> Female
              </Box>
            </MenuItem>

            <Divider />

            {/* Character Groups */}
            {characterMenuFilters.map((filter) => (
              <MenuItem key={filter.types} value={filter.types}>
                {filter.name}
              </MenuItem>
            ))}

            <Divider />

            {/* Status */}
            <MenuItem value="Alive">
              <Box display="flex" alignItems="center" gap={1}>
                <CircleIcon style={{ color: "#6EC531" }} /> Alive
              </Box>
            </MenuItem>

            <MenuItem value="Dead">
              <Box display="flex" alignItems="center" gap={1}>
                <CircleIcon style={{ color: "red" }} /> Dead
              </Box>
            </MenuItem>
          </Select>
        </FormControl>
      </Grid2>
    </Grid2>
  );
};

export default CharacterSearchAndFilter;
